// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BACK_TO_LIST_OF_GROUPS = "Zp\u011bt na seznam skupin";
export const GROUP_FIND_SOME_IN_A_LIST_OF_GROUPS_AND_FORUMS = "Najdi si n\u011bjakou v <0>Seznamu skupin a f\u00f3r</0> :-)";
export const GROUP_LIST = "Seznam skupin";
export const RECENT_COMMENTS = "Nejnov\u011bj\u0161\u00ed koment\u00e1\u0159e";
export const RECENT_POSTS = "Nejnov\u011bj\u0161\u00ed p\u0159\u00edsp\u011bvky";
export const YOU_ARE_NOT_IN_ANY_GROUP_SO_FAR = "Zat\u00edm nejsi v \u017e\u00e1dn\u00e9 skupin\u011b";
